// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_r_b","label":"styles_label__fnkae"};